import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { ServicesLandingComponent } from './services/services-landing.component';
import { AppointmentBookingComponent } from './appointments/appointment-booking.component';
import { AppointmentConfirmationComponent } from './appointments/appointment-confirmation.component';
import { DigitalDoorwayLandingComponent } from './digital-doorway/digital-doorway-landing.component';
import { RECAPTCHA_V3_SITE_KEY } from 'ng-recaptcha-2';

const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'services', component: ServicesLandingComponent },
  { path: 'appointments', component: AppointmentBookingComponent },
  { path: 'appointments/confirmation', component: AppointmentConfirmationComponent },
  { path: 'digital-doorway', component: DigitalDoorwayLandingComponent },
  { path: '**', redirectTo: '' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { bindToComponentInputs: true })],
  exports: [RouterModule],
  providers: [
    {
      provide: RECAPTCHA_V3_SITE_KEY,
      useValue: 'RecaptchaModule',
    },
  ],
})
export class AppRoutingModule {}
